<template>
  <div class="d-flex flex-column h-100"  style="background: url('./static/bg/bg_clubmet.jpg')no-repeat fixed center top / cover;">
    <section style="flex-grow: 2;">
      <header class="mt-4">
        <div class="container text-center">
          <img src="/static/logos/clubmet.png" alt="" height="150px" class="m-auto d-block">
          <h4 class="my-4" style="color:#E72176; text-shadow: 1px 1px #FFF;">Se parte del mejor club del Perú</h4>
        </div>
      </header>
      <main>
        <div class="container">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <el-form :model="formclub" ref="formclub" :label-position="'top'" class="p-4 border-none rounded mb-5" style="background:#00ADD8">
                <p class="text-center text-white fw-bolder" style="line-height:1.3;">
                  Regístrate en Club Met y obtén descuentos y accesos increíbles.</p>

                <div class="row">
                  <label class="form-label fw-bolder fs-6 text-white">Nombres completos</label>
                  <el-form-item prop="firstname" :rules="[
                    {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                  ]">
                    <el-input v-model="formclub.firstname" placeholder="Ingrese nombres" class="w-100" />
                  </el-form-item>
                </div>

                <div class="row">
                  <label class="form-label fw-bolder fs-6 text-white">Apellidos</label>
                  <el-form-item prop="lastname" :rules="[
                    {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                  ]">
                    <el-input v-model="formclub.lastname" placeholder="Ingrese apellidos" class="w-100" />
                  </el-form-item>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <label class="form-label fw-bolder fs-6 text-white">Documento</label>
                    <el-form-item prop="iddocument" :rules="[
                          {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                        ]">
                        <el-select v-model="formclub.iddocument" placeholder="Seleccione" filterable class="w-100">
                            <el-option
                              v-for="item in documents_identity"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                  </div>

                  <div class="col-sm-6">
                      <label class="form-label fw-bolder fs-6 text-white">Número</label>
                      <el-form-item prop="document" :rules="[
                        {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                      ]">
                        <el-input v-model="formclub.document" class="w-100" />
                      </el-form-item>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <label class="form-label fw-bolder fs-6 text-white">Celular</label>
                    <el-form-item prop="phone" :rules="[
                          {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                        ]">
                        <el-input v-model="formclub.phone" class="w-100" />
                    </el-form-item>
                  </div>

                  <div class="col-sm-6">
                      <label class="form-label fw-bolder fs-6 text-white">Fecha nacimiento</label>
                      <el-form-item prop="birthday" :rules="[
                        {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                      ]">
                        <el-date-picker v-model="formclub.birthday" type="date" placeholder="Seleccione un día" format="dd/MM/yyyy" class="w-100">
                        </el-date-picker>
                      </el-form-item>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <label class="form-label fw-bolder fs-6 text-white">Distrito</label>
                    <el-form-item prop="district" :rules="[
                          {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                        ]">
                        <el-input v-model="formclub.district" class="w-100" />
                    </el-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                      <label class="form-label fw-bolder fs-6 text-white">Dirección</label>
                      <el-form-item prop="address" :rules="[
                        {required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']}
                      ]">
                        <el-input v-model="formclub.address" placeholder="Ingrese dirección" class="w-100" />
                      </el-form-item>
                  </div>
                </div>



                <div class="row">
                  <div class="col-sm-12">
                    <label class="form-label fw-bolder fs-6 text-white">Correo electrónico</label>
                    <el-form-item label-width="120px" prop="email"
                        :rules="[
                          {required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur']},
                          {type: 'email', message: 'Ingrese una dirección de correo electrónico correcta', trigger: ['blur', 'change']}
                        ]">
                        <el-input v-model="formclub.email" placeholder="Correo electrónico" size="medium"></el-input>
                    </el-form-item>
                  </div>
                </div>

                <div class="row">
                  <div class="col d-flex justify-content-between">
                    <el-tooltip class="item" effect="dark" content="Has clic aquí para agregar mas asociados" placement="top">
                      <button type="button" class="btn btn-warning" @click="addPerson('formclub')">Agregar Socios</button>
                    </el-tooltip>
                    <button type="button" class="btn btn-danger" style="background-color:#E72176;" @click.prevent="payMe">Confirmar y pagar</button>
                  </div>
                </div>

                <div class="row" v-if="listPerson.length>0">
                  <div class="col-sm-12">
                    <div class="div border border-white my-4"></div>
                  </div>
                  <div class="col-sm-12">
                    <table class="table border w-100 bg-white">
                      <tr>
                        <th>N°</th>
                        <th>Nombres y apellidos</th>
                        <th>Opción</th>
                      </tr>
                      <tbody>
                        <tr v-for="(item, index) in listPerson" :key="'itm-' + index">
                          <td>{{index + 1}}</td>
                          <td>{{item.firstname}} {{item.lastname}}</td>
                          <td>
                            <button type="button" class="btn btn-light" @click="deleteItem(index)">
                              <i class="el-icon-delete"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </main>
    </section>

    <el-dialog
        title="ClubMet"
        :visible.sync="dialogVisible"
        width="30%" top="1vh" :close-on-click-modal="false">
        <el-form :model="formPay" ref="formPay" :label-position="'top'">
          <div class="text-center">
            <span style="color:#E72176">Monto total a pagar</span>
            <h1 style="color:#00ADD8">S/ {{listPerson.length * 10}}.00</h1>
          </div>

          <div class="row mb-4">
            <div class="col-sm-12">
              <label class="form-label fw-bolder fs-6">Recibir mis tarjetas en</label>
                 <el-select
                        v-model="formPay.idseat"
                        placeholder="Seleccione"
                        filterable class="w-100"
                      >
                        <el-option
                          v-for="item in listSeats"
                          :key="item.iddistrict"
                          :label="item.descripcion"
                          :value="item.iddistrict"
                        ></el-option>
                      </el-select>
            </div>
          </div>

          <!--<div class="row">
            <div class="col-sm-12">
              <label class="form-label fw-bolder fs-6">Selecciona el tipo de comprobante que deseas recibir</label>
            </div>
          </div>-->
          <Facturacion  @resFact="resFact" @resVolver="resVolver"></Facturacion>
        </el-form>

        <!--<span slot="footer" class="dialog-footer">
          <button class="btn btn-light" @click="dialogVisible = false">Cancelar</button>
          <button type="button" class="btn btn-danger" style="background-color:#E72176" @click="senPay">Ir a pagar</button>
        </span>-->
      </el-dialog>


  </div>
</template>
<script>
import dataJson from "@/data/common";
import moment from "moment";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

//components
import Facturacion from "@/components/common/BolFactura";

export default {
  components: {
        Facturacion,
    },
  data: () => ({
    dialogVisible: false,
    documents_identity: dataJson.documents_identity,
    formclub: {
      firstname: null,
      lastname: null,
      iddocument: null,
      document: null,
      phone: null,
      birthday: null,
      district: null,
      address:null,
      email: null
    },
    formPay: {
      idseat: null
    },
    listPerson: [],
    listSeats: [],
  }),
  methods: {
    getListSeats() {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      axios.get(`${process.env.API8}/api/distritos`).then((response) => {
        this.listSeats = response.data;
        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
      });
    },

    addPerson(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)
          return false

          this.savePerson(formName)
      })
    },

    savePerson(formName){
      let tmperson = {
        index: this.listPerson.length + 1,
        firstname: this.formclub.firstname,
        lastname: this.formclub.lastname,
        iddocument: this.formclub.iddocument,
        documento: this.formclub.document,
        phone: this.formclub.phone,
        birthday: moment( this.formclub.birthday ).format('YYYY-MM-DD'),
        email: this.formclub.email,
        address: '',
        district: '',
        kinship: '1',
        sex: 'M'
      }
      this.listPerson.push(tmperson)
      this.$notify.success( {title: 'Perfecto', message: this.formclub.firstname + ' se agregó a la lista de beneficiados.'});
      this.limpiar()

    },

    limpiar(){
      this.formclub.firstname = null;
      this.formclub.lastname = null;
      this.formclub.iddocument = null;
      this.formclub.document = null;
      this.formclub.phone = null;
      this.formclub.birthday = null;
      this.formclub.email = null;
    },

    payMe(){
      if(this.listPerson.length > 0){
        this.dialogVisible = true
      }else{
        this.$notify.error( {title: 'Lo sentimos', message: 'su lista de beneficiados está vacía' });
      }
    },

    resVolver(data) {
      this.dialogVisible = false
    },

    senPay(facturacion){
      this.dialogVisible = false
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      axios
        .post(`${process.env.API8}/api/register`, {
            idseat: this.formPay.idseat,
            quantityCard: this.listPerson.length,
            fndoc: facturacion.fndoc,
            fname: facturacion.fname,
            fphone: facturacion.fphone,
            femail: facturacion.femail,
            voucher: facturacion.voucher,
            terms: facturacion.terms,
            ordercategory: 14,
            source:2,
            socios: this.listPerson,
          })
        .then((response) => {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            if (response.data.status)
                window.location.href = response.data.url;
            else this.$notify.error( {title: 'Lo sentimos', message: response.data.message });
        })
        .catch((err) => {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify.error( {title: 'Lo sentimos', message:'Se ha producido un error interno'});
        });
    },

     resFact(data) {
      this.senPay(data)
    },

    deleteItem(index){
      //alert(index)
      this.listPerson.splice(index, 1)
    }
  },
   created() {
    this.getListSeats();
  },

}
</script>



// WEBPACK FOOTER //
// src/components/pages/clubmet/Index.vue